import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import storageService from 'portaltransparencia-common/libs/StorageService.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';

import LinkToEmpenho from '../empenhos/LinkToEmpenho.react';

export default class LiquidacaoTable extends Component {
  static propTypes = {
    liquidacao: PropTypes.object.isRequired,
    tipo: PropTypes.string.isRequired,
    paramDespesasPagasValor: PropTypes.string
  };

  onViewEmpenho = item => {
    const { tipo } = this.props;
    const entidade = item.get('entidade');
    const exercicio = item.get('exercicio');
    const empenho = item.get('empenho');

    let active = 'liquidacoes';
    if (tipo == 'pagas') {
      active = 'pagamentos';
    }

    this.props.history.push(
      `/empenhos/detalhe?search=id.entidade==${entidade}&entidade=${entidade}&exercicio=${exercicio}&empenho=${empenho}&active=${active}`
    );
  };

  generateKey = liquidacao => {
    return `${liquidacao.get('entidade')}_
            ${liquidacao.get('exercicio')}_
            ${liquidacao.get('empenhoExercicio')}_
            ${liquidacao.get('empenho')}_
            ${liquidacao.get('data')}_
            ${liquidacao.get('noLiquidacao')}_
            ${liquidacao.get('valor')}`;
  };

  render() {
    const { liquidacao, tipo } = this.props;
    const { entidade } = storageService.getItem('userInfo');
    return (
      <TableActions
        ref="row"
        key={this.generateKey(liquidacao)}
        data={liquidacao}
        onMore={this.onViewEmpenho}
      >
        {entidade && entidade.id <= 0 && (
          <td className="center">{liquidacao.get('entidade')}</td>
        )}
        {tipo === 'aptos-pagamentos' && (
          <td>{liquidacao.get('ordemFonteRecurso')}</td>
        )}
        <td>{liquidacao.get('fonteRecurso')}</td>
        <td className="right">
          {DateUtils.formatDateTimeShort(liquidacao.get('data'))}
        </td>
        <td className="right">
          <LinkToEmpenho
            entidade={liquidacao.get('entidade')}
            exercicio={liquidacao.get('exercicio')}
            empenho={liquidacao.get('empenho')}
          />
        </td>
        <td className="right">{liquidacao.get('noLiquidacao')}</td>
        <td>{liquidacao.get('fornecedor')}</td>
        <td>{liquidacao.get('tipoLicitacao')}</td>
        <td className="right">{liquidacao.get('licitacao')}</td>
        <td>{liquidacao.get('notasFiscais')}</td>
        <td className="right">
          {tipo === 'pagas' && this.props.paramDespesasPagasValor === 'S' ? (
            <NumberFormatter
              id="valor"
              value={liquidacao.get('valorParametro')}
            />
          ) : (
            <NumberFormatter id="valor" value={liquidacao.get('valor')} />
          )}
        </td>
        <td className="right">
          {tipo === 'pagas' && this.props.paramDespesasPagasValor === 'S' ? (
            <NumberFormatter
              id="valorsaldo"
              value={liquidacao.get('valorParametro')}
            />
          ) : (
            <NumberFormatter id="valorsaldo" value={liquidacao.get('saldo')} />
          )}
        </td>
      </TableActions>
    );
  }
}
